export class NotificationStatusMapper {
  private static statusMap = new Map<number, string>([
    [0, "Draft"],
    [1, "Active"],
    [2, "Upcoming"],
    [3, "Past"],
  ]);

  static getNotificationStatusName(statusId: number): string {
    return this.statusMap.get(statusId) ?? "Unknown";
  }

  private static reverseMap = new Map<string, number>(
    Array.from(NotificationStatusMapper.statusMap.entries()).map(([id, name]) => [name.toLowerCase(), id])
  );

  static getNotificationStatusId(statusName: string): number | null {
    return this.reverseMap.get(statusName.toLowerCase()) ?? null;
  }
}